var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper,on:{"click":_vm.handleWrapperClick}},[_c('QuestProgress',{attrs:{"is-claim-button-shown":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }